import React from 'react';
import { 
  LayoutDashboard, 
  ShoppingBag, 
  Package, 
  Users, 
  Settings, 
  BarChart3,
  Wrench,
  LogOut,
  Car,
  Tag,
  Bell,
  Layers,
  Image,
  Database,
  Trash2
} from 'lucide-react';

const AdminSidebar = ({ currentPage, setCurrentPage, onLogout, isMobileOpen, setIsMobileOpen }) => {
  const menuItems = [
    { id: 'dashboard', name: 'لوحة التحكم', icon: LayoutDashboard },
    { id: 'hero', name: 'البانر الرئيسي', icon: Image },
    { id: 'orders', name: 'جميع الطلبات', icon: ShoppingBag },
    { id: 'bookings', name: 'الحجوزات', icon: Car },
    { id: 'purchases', name: 'المشتريات', icon: Package },
    { id: 'categories', name: 'التصنيفات', icon: Tag },
    { id: 'products', name: 'المنتجات', icon: Layers },
    { id: 'services', name: 'الخدمات', icon: Wrench },
    { id: 'modifications', name: 'التعديلات', icon: Settings },
    { id: 'notifications', name: 'الإشعارات', icon: Bell },
    { id: 'customers', name: 'العملاء', icon: Users },
    { id: 'seed-data', name: 'إضافة بيانات تجريبية', icon: Database },
    { id: 'clear-seed-data', name: 'حذف البيانات التجريبية', icon: Trash2 },
    { id: 'analytics', name: 'التحليلات', icon: BarChart3 },
    { id: 'settings', name: 'الإعدادات', icon: Settings },
  ];

  const handleMenuClick = (pageId) => {
    setCurrentPage(pageId);
    if (setIsMobileOpen) {
      setIsMobileOpen(false);
    }
  };

  return (
    <>
      {/* Mobile Overlay */}
      {isMobileOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={() => setIsMobileOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div className={`
        fixed lg:sticky top-0 right-0 h-screen w-64 bg-gradient-to-b from-gray-900 to-gray-800 
        text-white z-50 transform transition-transform duration-300 ease-in-out
        ${isMobileOpen ? 'translate-x-0' : 'translate-x-full lg:translate-x-0'}
      `}>
        <div className="flex flex-col h-full">
          {/* Logo */}
          <div className="p-6 border-b border-gray-700">
            <div className="flex items-center gap-3">
              <div className="bg-yellow-500 p-2 rounded-lg">
                <Car className="w-6 h-6 text-gray-900" />
              </div>
              <div>
                <h1 className="text-xl font-bold">لوحة التحكم</h1>
                <p className="text-xs text-gray-400">إدارة الموقع</p>
              </div>
            </div>
          </div>

          {/* Menu Items */}
          <nav className="flex-1 overflow-y-auto py-4 px-3">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const isActive = currentPage === item.id;
              
              return (
                <button
                  key={item.id}
                  onClick={() => handleMenuClick(item.id)}
                  className={`
                    w-full flex items-center gap-3 px-4 py-3 mb-2 rounded-lg
                    transition-all duration-200 text-right
                    ${isActive 
                      ? 'bg-yellow-500 text-gray-900 shadow-lg' 
                      : 'hover:bg-gray-700 text-gray-300 hover:text-white'
                    }
                  `}
                >
                  <Icon className="w-5 h-5 flex-shrink-0" />
                  <span className="font-medium">{item.name}</span>
                </button>
              );
            })}
          </nav>

          {/* Logout Button */}
          <div className="p-4 border-t border-gray-700">
            <button
              onClick={onLogout}
              className="w-full flex items-center gap-3 px-4 py-3 rounded-lg
                       bg-red-600 hover:bg-red-700 transition-colors text-white"
            >
              <LogOut className="w-5 h-5" />
              <span className="font-medium">تسجيل الخروج</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminSidebar;
